import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-warning',
  templateUrl: './card-warning.component.html',
  styleUrls: []
})
export class CardWarningComponent implements OnInit {

  @Input() id = '';
  @Input() title = '';
  @Input() text = '';
  @Input() screenReaderText = '';

  isTitleEmpty = true;

  ngOnInit() {
    this.isTitleEmpty = this.isEmpty(this.title);
  }

  isEmpty(text: string) {
    return text === undefined || text === null || text === '';
  }
}
